import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  action: "insert",

  mob: null,
  name: null,
  pos: null,
  role: null,
  invRecip: false,
  tel: null,
  email: null,
};

export const sponsorInfoSlice = createSlice({
  name: "sponsorInfo",
  initialState,
  reducers: {
    updateAction: (state, action) => {
      return {
        ...state,
        action: action.payload.action,
      };
    },

    updateMob: (state, action) => {
      return {
        ...state,
        mob: action.payload.mob,
      };
    },

    updateName: (state, action) => {
      return {
        ...state,
        name: action.payload.name,
      };
    },

    updatePos: (state, action) => {
      return {
        ...state,
        pos: action.payload.pos,
      };
    },

    updateRole: (state, action) => {
      return {
        ...state,
        role: action.payload.role,
      };
    },

    updateTel: (state, action) => {
      return {
        ...state,
        tel: action.payload.tel,
      };
    },

    updateEmail: (state, action) => {
      return {
        ...state,
        email: action.payload.email,
      };
    },

    updateInvRecip: (state, action) => {
      return {
        ...state,
        invRecip: action.payload.invRecip,
      };
    },

    init: (state, action) => {
      return {
        ...initialState,
      };
    },

    updateAll: (state, action) => {
      return { ...action.payload };
    },
  },
});

export const {
  updateAction,
  updateMob,
  updateName,
  updatePos,
  updateRole,
  updateEmail,
  updateTel,
  updateInvRecip,
  init,
  updateAll,
} = sponsorInfoSlice.actions;

export default sponsorInfoSlice.reducer;
